import { getProgramLifeCycleById } from '../../products/common/services/program-service';
import { modalUtils } from '@/app/core/utils';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import dayjs, { extend as dayJSExtend } from 'dayjs';
import { ProgramLifeCycle, Job } from '@ssar-app/domain';
import duration from 'dayjs/plugin/duration';
import {
  AccordionTimeline,
  Empty,
  Spin,
  Timeline,
  TimelineDataProps,
} from '@ssar-app/uikit';
dayJSExtend(duration);
interface transitions {
  id?: string;
  stateFrom: string;
  stateTo: string;
  timeSpentInMilliSeconds: number;
  transSource: string;
  transTimeStamp: number;
  updateSource: string;
  message?: string;
}
interface programLifeCycleProps {
  job: Job;
  isOpen: boolean;
  setOpen: (arg0: boolean) => void;
}
const emailPattern = /^\w.+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

export const ProgramLifeCycleModel = (props: programLifeCycleProps) => {
  const { job, isOpen, setOpen } = props;
  const { onClose } = useDisclosure();
  const [timelineData, setTimelineData] = useState<TimelineDataProps[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modelData, setModelData] = useState<ProgramLifeCycle>();
  const [transitions, setStateTransitions] = useState<transitions[]>([]);
  const getTransactionSource = (TransactionSource: string) =>
    emailPattern.test(TransactionSource) ? TransactionSource : 'SYSTEM';
  useEffect(() => {
    getProgramLifeCycleById(job.externalSystemRef)
      .then((response) => {
        if (response.status !== 'Success') {
          setOpen(false);
          modalUtils.showError(
            response,
            'Error while fetching Program Audit Trail.',
          );
        } else {
          setModelData(response.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
        modalUtils.showError(err, 'Error while fetching the Program details');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [job, setOpen]);

  useEffect(() => {
    const StateTrans: transitions[] = modelData?.stateTransitions
      ? modelData?.stateTransitions.filter(
          (elm: transitions) => elm.stateFrom != elm.stateTo,
        )
      : [];
    setStateTransitions(StateTrans);
  }, [modelData]);

  useEffect(() => {
    setTimelineData(
      transitions.map((entry: transitions) => ({
        title:
          entry.stateFrom.toLowerCase() === 'none'
            ? 'RECEIVED'
            : entry.stateFrom,
        titleIcon: '',
        status: entry.stateFrom.toLowerCase(),
        details: (
          <Timeline>
            <Text fontSize='xs'>
              Transaction Time:{' '}
              {dayjs(entry.transTimeStamp).format(
                'YYYY-MMM-DD HH:mm:ss [GMT]ZZ',
              )}
            </Text>
            <Text fontSize='xs'>
              Duration:{' '}
              {dayjs.duration(entry.timeSpentInMilliSeconds).humanize()}
            </Text>
            <Text fontSize='xs'>
              Transaction Source:{' '}
              {getTransactionSource(
                entry.transSource ? entry.transSource : entry.updateSource,
              )}
            </Text>
            {entry?.message && entry.message != '' && (
              <Text fontSize='xs'>Message: {entry?.message} </Text>
            )}
          </Timeline>
        ),
      })),
    );
  }, [transitions]);
  return (
    <Drawer
      onClose={() => {
        setOpen(false);
        onClose();
      }}
      isOpen={isOpen}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={false}
      size={'sm'}
      placement='left'
    >
      <DrawerOverlay />
      <DrawerContent className={'program-life-cycle-inline'}>
        <DrawerCloseButton />
        <DrawerHeader>
          <>
            <Text>Program Audit Trail</Text>
            <Text p={1} fontSize='sm'>
              Program Name:{' '}
              <Text fontSize='sm' display={'inline'} fontWeight='normal'>
                {job.programName}
              </Text>
            </Text>
          </>
        </DrawerHeader>
        <DrawerBody>
          <Spin spinning={isLoading} tip='Loading Program Details...'>
            {modelData && (
              <div className='auditReportDisp'>
                {transitions.length > 0 ? (
                  <AccordionTimeline
                    data={[
                      ...timelineData,
                      {
                        title: transitions[transitions.length - 1].stateTo,
                        titleIcon: '',
                        status:
                          transitions[
                            transitions.length - 1
                          ].stateTo.toLowerCase(),
                        details: '',
                      },
                    ]}
                    accordionProps={{
                      defaultIndex: Object.keys(transitions).map((index) =>
                        parseInt(index),
                      ),
                    }}
                  />
                ) : (
                  <Empty description={'Program Audit Trail Not Found'} />
                )}
              </div>
            )}
          </Spin>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
